import { render, staticRenderFns } from "./StallionCommandes.vue?vue&type=template&id=9dd4eb96&"
import script from "./StallionCommandes.vue?vue&type=script&lang=js&"
export * from "./StallionCommandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports